import { createNoLoadActionTypes } from './utils';

export const SET_BREADCRUMB = createNoLoadActionTypes('SET_BREADCRUMB');
export const RESET_BREADCRUMB = createNoLoadActionTypes('RESET_BREADCRUMB');
